<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="培训意见反馈" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="danger" v-if="editData.djzt === '生效'" @click="unSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-spin :spinning="loading">
                <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="padding:10px 20px;">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="反馈表编号">
                                <a-input ref="yjfkbbh" v-model="editData.yjfkbbh" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="反馈日期">
                                <a-input ref="fkrq" v-model="editData.fkrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名单位编号">
                                <a-input ref="fkdwbh" v-model="editData.fkdwbh" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名单位名称">
                                <a-input ref="fkdwmc" v-model="editData.fkdwmc" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="班级名称">
                                <a-input ref="bjmc" v-model="editData.bjmc" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="班级类别">
                                <a-input ref="bjlb" v-model="editData.bjlb" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="班级人数">
                                <a-input ref="bjrs" v-model="editData.bjrs" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名人数">
                                <a-input ref="bmrs" v-model="editData.bmrs" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名开始日期">
                                <a-input ref="ksrq" v-model="editData.ksrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="报名结束日期">
                                <a-input ref="jsrq" v-model="editData.jsrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训开始日期">
                                <a-input ref="pxksrq" v-model="editData.pxksrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训结束日期">
                                <a-input ref="pxjsrq" v-model="editData.pxjsrq" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训内容">
                                <a-input ref="pxnr" v-model="editData.pxnr" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="培训地点">
                                <a-input ref="pxdd" v-model="editData.pxdd" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="联系人">
                                <a-input ref="lxr" v-model="editData.lxr" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="联系电话">
                                <a-input ref="lxdh" v-model="editData.lxdh" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入部门">
                                <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入人">
                                <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="录入时间">
                                <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="反馈意见" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="fkyj" :rows="3" v-model="editData.fkyj" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="课程安排" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="kcap" :rows="3" v-model="editData.kcap" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="教师评价" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="jspj" :rows="3" v-model="editData.jspj" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="组织管理" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="zzgl" :rows="3" v-model="editData.zzgl" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="[0, 6]">
                        <a-col :span="24">
                            <a-form-item label="培训建议" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                <a-textarea ref="pxyj" :rows="3" v-model="editData.pxyj" disabled />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
                <!-- 流程跟踪组件 -->
                <OperLog ref="activitishow" :operLogProps="operLogProps"></OperLog>
            </a-spin>
        </a-page-header>
    </div>
</template>
<script>
export default {
    name: "PxyjfkForm",
    props: ["showForm", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 培训记录明细数据
            editItemData: [],
            editItemDataLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            }
        };
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
                this.operLogProps.visible = newVal;
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.yjfkbbh.focus();
        });
    },
    methods: {
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/pxyjfk/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        },
        unSubmit() {
            this.$FG_http
                .post("./api/main/jsry/pxyjfk/unSubmit", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.yjfkbbh.focus();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        },
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        }
    }
};
</script>
